import React, { Component } from 'react';
import Select from '@mui/material/Select';
import { matchPath, Route, withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import {
  getColleges,
  getCohortTypes,
  getCalendarTypes,
  getCourseAttemptStatus,
  getCampusLocations
} from '../../services/reservoir';
import {
  getDefaultFilterOptions,
  saveFilterOptions,
  getPreviewModeEnabled,
  setPreviewModeEnabled
} from '../../services/liveview';

const mapStateToProps = ({
  courses: { selectedCourseCode, data },
  course: { selectedCourse },
  enrolledTeachingPeriods: enrolledTeachingPeriods
}) => {
  return {
    selectedCourse: selectedCourse,
    currentFilterOptions: {
      admissionCategory: selectedCourse.admissionCategory,
      courseAttemptStatus: selectedCourse.courseAttemptStatus,
      teachingPeriods: enrolledTeachingPeriods[selectedCourseCode].teachingPeriods,
      college: selectedCourse.orgUnit,
      campus: selectedCourse.locationCd
    }
  };
};

function arrayContainsArray(superset, subset) {
  if (0 === subset.length) {
    return false;
  }
  return subset.every(function(value) {
    return superset.indexOf(value) >= 0;
  });
}

class FilterOptions extends Component {
  constructor(props) {
    super(props);

    this.state = {
      cohortOptions: [],
      selectedCohort: null,

      collegeOptions: [],
      selectedCollege: null,

      calendarOptions: [],
      selectedCalendar: null,

      enrolmentTypeOptions: [],
      selectedEnrolmentType: null,

      campusLocationOptions: [],
      selectedCampusLocation: null
    };
  }

  componentDidMount() {
    this.retrieveFilterOptions();
  }

  selectDefaultFilterOptions = defaultFilters => {
    let selectedCohort = this.state.cohortOptions.find(item =>
      item.value.includes(defaultFilters.admissionCategory)
    );

    let selectedCalendar = this.state.calendarOptions.find(item =>
      arrayContainsArray(item.value, defaultFilters.teachingPeriods)
    );

    let selectedCourseAttemptStatus = this.state.enrolmentTypeOptions.find(
      item => item.value == defaultFilters.courseAttemptStatus
    );

    let selectedCollege = this.state.collegeOptions.find(
      item => item.value == defaultFilters.college
    );

    let selectedCampusLocation = this.state.campusLocationOptions.find(
      item => item.value == defaultFilters.campus
    );

    this.setState({
      selectedCohort: selectedCohort,
      selectedCalendar: selectedCalendar,
      selectedEnrolmentType: selectedCourseAttemptStatus,
      selectedCollege: selectedCollege,
      selectedCampusLocation: selectedCampusLocation
    });
  };

  retrieveFilterOptions = () => {
    Promise.all([
      getCohortTypes(),
      getColleges(),
      getCalendarTypes(),
      getCourseAttemptStatus(),
      getCampusLocations()
    ]).then(([cohorts, colleges, calendars, courseAttemptStatuses, campus]) => {
      let cohortOptions = this.populateCohortOptions(cohorts);
      let collegeOptions = this.populateCollegeOptions(colleges);
      let calendarOptions = this.populateCalendarOptions(calendars);
      let courseAttemptStatusOptions = this.populateCourseAttemptStatusOptions(
        courseAttemptStatuses
      );
      let campusOptions = this.populateCampusOptions(campus);

      this.setState(
        {
          cohortOptions: cohortOptions,
          collegeOptions: collegeOptions,
          calendarOptions: calendarOptions,
          enrolmentTypeOptions: courseAttemptStatusOptions,
          campusLocationOptions: campusOptions
        },
        () => {
          this.selectDefaultFilterOptions(this.props.currentFilterOptions);
        }
      );
    });
  };

  populateCohortOptions = items => {
    let options = [];
    items.map(item =>
      options.push({
        label: item.attributes.name,
        value: item.attributes.field_test
      })
    );
    return options;
  };

  populateCollegeOptions = items => {
    let options = [];

    options.push({
      label: 'All',
      value: null
    });

    items.map(item =>
      options.push({
        label: item.attributes.name,
        value: item.attributes.field_college_code
      })
    );
    return options;
  };

  populateCampusOptions = items => {
    let options = [];

    items.map(item =>
      options.push({
        label: item.attributes.name,
        value: item.attributes.field_location_code
      })
    );
    return options;
  };

  populateCalendarOptions = items => {
    let options = [];
    items.map(item =>
      options.push({
        label: item.attributes.name,
        value: item.attributes.field_machine_name.map(subitem => subitem.value)
      })
    );
    return options;
  };

  populateCourseAttemptStatusOptions = items => {
    let options = [];
    items.map(item =>
      options.push({
        label: item.attributes.name,
        value: item.attributes.field_machine_code
      })
    );
    return options;
  };

  handleCohortSelected = item => {
    this.setState({
      selectedCohort: item
    });
  };

  handleCollegeSelected = item => {
    this.setState({
      selectedCollege: item
    });
  };

  handleCalendarSelected = item => {
    this.setState({
      selectedCalendar: item
    });
  };

  handleEnrolmentSelected = item => {
    this.setState({
      selectedEnrolmentType: item
    });
  };

  handleCampusSelected = item => {
    this.setState({
      selectedCampusLocation: item
    });
  };

  handleApplyClicked = event => {
    const isPreviewEnabled = getPreviewModeEnabled();

    localStorage.clear();
    sessionStorage.clear();

    setPreviewModeEnabled(isPreviewEnabled);

    let filterOptions = {
      admissionCategory: this.state.selectedCohort.value[0],
      courseAttemptStatus: this.state.selectedEnrolmentType.value,
      teachingPeriods: this.state.selectedCalendar.value,
      college: this.state.selectedCollege.value,
      campus: this.state.selectedCampusLocation.value
    };

    saveFilterOptions(filterOptions);

    window.location.reload();
  };

  handleClearClicked = event => {
    const defaultFilterOptions = getDefaultFilterOptions();
    this.selectDefaultFilterOptions(defaultFilterOptions);
  };

  render() {
    return (
      <div className="filter-container1">
        <div className="title">Customise Filters</div>

        <div className="filter-options">
          <div className="filter-option">
            <label>Cohort</label>
            <Select
              name="cohort"
              value={this.state.selectedCohort}
              options={this.state.cohortOptions}
              onChange={this.handleCohortSelected}
            />
          </div>
          <div className="filter-option">
            <label>College</label>
            <Select
              name="college"
              value={this.state.selectedCollege}
              options={this.state.collegeOptions}
              onChange={this.handleCollegeSelected}
            />
          </div>
          <div className="filter-option">
            <label>Calendar Type</label>
            <Select
              name="Calendar"
              value={this.state.selectedCalendar}
              options={this.state.calendarOptions}
              onChange={this.handleCalendarSelected}
            />
          </div>
          <div className="filter-option">
            <label>Enrolment Status</label>
            <Select
              name="Enrolment"
              value={this.state.selectedEnrolmentType}
              options={this.state.enrolmentTypeOptions}
              onChange={this.handleEnrolmentSelected}
            />
          </div>
          <div className="filter-option">
            <label>Campus Location</label>
            <Select
              name="Campus"
              value={this.state.selectedCampusLocation}
              options={this.state.campusLocationOptions}
              onChange={this.handleCampusSelected}
            />
          </div>
        </div>

        <div className="buttons">
          <a className="link-box1" onClick={this.handleApplyClicked}>
            Apply Filters
          </a>
          <a className="link-box2" onClick={this.handleClearClicked}>
            Reset
          </a>
        </div>
      </div>
    );
  }
}

export default withRouter(connect(mapStateToProps)(FilterOptions));
